import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
    dialogActions: {
        justifyContent: 'space-between'
    },
}));

export default function CopyElectionDialog(props) {

    const classes = useStyles();

    const { open, onClose, handleCopyElection } = props;

    const [ copyProposals, setCopyProposals ] = useState(true);
    const [ copyAcceptedProposals, setCopyAcceptedProposals ] = useState(false);
    const [ copyRejectedProposals, setCopyRejectedProposals ] = useState(false);
    const [ copyRecommendations, setCopyRecommendations ] = useState(true);
    const [ copyFields, setCopyFields ] = useState(true);

    const handleCopyFields = () => {
        if (copyFields && copyProposals) {
            setCopyProposals(false);
        }

        if (copyFields && copyAcceptedProposals) {
            setCopyAcceptedProposals(false);
        }

        if (copyFields && copyRejectedProposals) {
            setCopyRejectedProposals(false);
        }

        setCopyFields(!copyFields);
    }

    const handleClose = () => {
        onClose();
    }

    const handleCopy = () => {

        handleCopyElection({
            copyProposals: copyProposals,
            copyAcceptedProposals: copyAcceptedProposals,
            copyRejectedProposals: copyRejectedProposals,
            copyRecommendations: copyRecommendations,
            copyFields: copyFields,
        });

        handleClose();
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="xs"
            aria-labelledby="copy-election-title"
            >
            <DialogTitle id="copy-election-title">
                Copy Election
            </DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>
                    Please select the election items you would like to copy below. Please note, you can NOT copy proposals without copying fields. Fields may be adjusted later in settings.
                </Typography>
                <FormControlLabel
                    control={
                        <Switch
                            checked={copyFields}
                            onChange={handleCopyFields}
                            color="primary"
                            value="copy-fields"
                        />
                    }
                    label="Copy All Fields"
                    margin="normal"
                    fullWidth
                />
                <br/>
                <FormControlLabel
                    control={
                        <Switch
                            checked={copyProposals}
                            onChange={() => setCopyProposals(!copyProposals)}
                            color="primary"
                            value="copy-proposals"
                            disabled={copyFields === false}
                        />
                    }
                    label="Copy Active Proposals"
                    margin="normal"
                    fullWidth
                />
                <br/>
                <FormControlLabel
                    control={
                        <Switch
                            checked={copyAcceptedProposals}
                            onChange={() => setCopyAcceptedProposals(!copyAcceptedProposals)}
                            color="primary"
                            value="copy-accepted-proposals"
                            disabled={copyFields === false}
                        />
                    }
                    label="Copy Accepted Proposals"
                    margin="normal"
                    fullWidth
                />
                <br/>
                <FormControlLabel
                    control={
                        <Switch
                            checked={copyRejectedProposals}
                            onChange={() => setCopyRejectedProposals(!copyRejectedProposals)}
                            color="primary"
                            value="copy-rejected-proposals"
                            disabled={copyFields === false}
                        />
                    }
                    label="Copy Rejected Proposals"
                    margin="normal"
                    fullWidth
                />
                <br/>
                <FormControlLabel
                    control={
                        <Switch
                            checked={copyRecommendations}
                            onChange={() => setCopyRecommendations(!copyRecommendations)}
                            color="primary"
                            value="copy-recommendations"
                        />
                    }
                    label="Copy Associated Recommendations"
                    margin="normal"
                    fullWidth
                    disabled={!copyProposals && !copyProposals && !copyRejectedProposals}
                />
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button onClick={handleClose}>
                    Cancel
                </Button>
                <Button
                    onClick={handleCopy}
                    variant="contained"
                    color='primary'
                    >
                    Copy Election
                </Button>
           </DialogActions>
        </Dialog>
    )
}